let isLocal = location.origin.includes("l.ezoic.com");

let API_BASE_URL = "https://qa-bot-backend.ezoic.com";
if (isLocal) {
    API_BASE_URL = "https://l.ezoic.com:13000";
}

export default {
    isLocal() {
        return isLocal;
    },
    getBaseUrl() {
        return API_BASE_URL;
    },
};